import React, { Fragment } from 'react';
import AbstractComponent from '../AbstractComponent';
import ContentPesquisa from '../layout/content/ContentPesquisa';
import ModalQuestion from '../layout/modal/ModalQuestion';

import PedidoService from '../../service/PedidoService';

import AcaoEnum from '../../helper/enumerador/AcaoEnum';
import AlignEnum from '../layout/table/AlignEnum';
import FormCodeEnum from '../../helper/enumerador/FormCodeEnum';
import StatusPedidoEnum from '../../helper/enumerador/StatusPedidoEnum';
import TableTypeEnum from '../layout/table/TableTypeEnum';
import FilterTypeEnum from '../layout/filter/FilterTypeEnum';

class Pedido extends AbstractComponent { 
    constructor(props) {
        super(props);        

        this.state = {            
            head : [
                {nome: 'Nº Pedido', campo: 'id', width: '8%'},
                {nome: 'Data', campo: 'data', width: '14%', type: TableTypeEnum.DATETIME},
                {nome: 'Cliente', campo: 'destinatario', width: '28%'},
                {nome: 'Total', campo: 'totalizador.total', width: '20%', type: TableTypeEnum.MOEDA, align: AlignEnum.RIGHT},
                {nome: 'Status', campo: 'status', width: '20%'}
            ],                                           

            callBack: {
                id: 1,

                body: [],

                pagination: [],

                recordCount: 0,

                indice: -1,

                mensagem: {
                    message: '',
                    code: 0
                },

                acao: AcaoEnum.NOTHING
            },

            removerItem: -1,

            removerIndice: -1,            

            preloadFilter: false,

            preload: false
        }     
        
        this.filter = [
            {nome: 'Nº Pedido', campo: 'id', valor: "", type: FilterTypeEnum.NUMBER, md: "6", xs: "6", sm: "6", lg: "6"},
            {nome: 'Data', campo: 'data', valor:"", type: FilterTypeEnum.DATE, md: "6", xs: "6", sm: "6", lg: "6"},
            {nome: 'Cliente', campo: 'cliente', valor:"", type: FilterTypeEnum.TEXT, md: "12", xs: "12", sm: "12", lg: "12"},
            {nome: 'Status', campo: 'status', valor:"", type: FilterTypeEnum.SELECT, options: StatusPedidoEnum.getOptions(), md: "6", xs: "12", sm: "6", lg: "6"}
        ]; 
    }        
    
    cancelarPedido() {           
        this.setState({preload: true});

        PedidoService.cancelarPedido(
            this.state.removerItem,
            this.props.usuario.nome
        ).then(resposta => {
            let callBack = this.state.callBack;

            callBack.id++;            
            callBack.mensagem = {
                message: 'Pedido cancelado com sucesso',
                code: FormCodeEnum.DEFAULT
            };
            
            let body = callBack.body;

            body[this.state.removerIndice].status = StatusPedidoEnum.PEDIDO_CANCELADO.name;

            callBack.body = body;

            this.setState({ 
                callBack: callBack,
                removerItem: -1,
                removerIndice: -1,
                preload: false
            });
        }).catch(erro => {                        
            let callBack = this.state.callBack;

            callBack.id++;            
            callBack.mensagem = this.trataErro(erro);
            callBack.acao = AcaoEnum.ERRO;            

            let body = callBack.body;

            body[this.state.removerIndice].status = StatusPedidoEnum.PEDIDO_CANCELADO.name;

            callBack.body = body;
            
            this.setState({ 
                callBack: callBack,
                removerItem: -1,
                removerIndice: -1,
                preload: false 
            });
        })        
    }    

    actions(item, index) {
        if(item.status === StatusPedidoEnum.PEDIDO_CANCELADO.name) {
            return ;
        }

        return (
            <button 
                type="button"    
                className="btnDanger"    
                title="Cancelar Pedido"                     
                style={{marginLeft: '5px', marginRight: '5px'}}
                onClick={() => this.setState({removerItem: item.id, removerIndice: index})}
            >
                <i className="fa fa-times" />
            </button>
        );
    }

    onCallbackFilter(resposta, erro) {
        if(erro) {
            let callBack = this.state.callBack;
            
            callBack.mensagem = this.trataErro(erro);
            callBack.indice = -1;
            callBack.acao = AcaoEnum.ERRO;

            this.setState({ callBack: callBack });

            return ;
        }

        let callBack = this.state.callBack;

        callBack.id++;        
        callBack.body = resposta.data.dados;
        callBack.pagination = resposta.data.pagination;
        callBack.mensagem = {
            message: '',
            code: 0
        };
        callBack.acao = AcaoEnum.LOAD;            
        callBack.indice = -1;

        this.setState({ callBack: callBack });        
    }          

    onLoad() {        
        PedidoService.listar(
            [],
            1
        ).then(resposta => {
            let callBack = this.state.callBack;

            callBack.mensagem = {
                message: '',
                code: 0
            };
            callBack.body = resposta.data.dados;
            callBack.pagination = resposta.data.pagination;           
            callBack.acao = AcaoEnum.LOAD;            
            callBack.indice = -1;

            this.setState({ 
                callBack: callBack,                          
            });
        }).catch(erro => {
            let callBack = this.state.callBack;
            
            callBack.mensagem = this.trataErro(erro);
            callBack.indice = -1;
            callBack.acao = AcaoEnum.ERRO;

            this.setState({ callBack: callBack });
        })
    }

    render() {
        return (   
            <Fragment>
                <ModalQuestion
                    show={this.state.removerIndice > -1}
                    styleIcon="fas fa-question-circle"
                    header="Pergunta"
                    texto="Tem certeza de que deseja cancelar o pedido?"
                    preload={this.state.preload}

                    btnSimClick={() => this.cancelarPedido()}
                    btnNaoClick={() => this.setState({ removerIndice: -1, removerItem: -1 })}
                    fechar={() => this.setState({ removerIndice: -1, removerItem: -1 })}
                /> 

                <ContentPesquisa 
                    title="Lista de Pedidos"                    

                    modalErroMsg={this.state.modalErroMsg}                    
                    
                    head={this.state.head}  
                    filter={this.filter}                
                    searchService={PedidoService.listar}                                           

                    cadastro={false}
                    editar={false}     
                    view={true}
                    filtered={true}
                    actions={(item, index) => this.actions(item, index)}           
                    callBack={this.state.callBack}                     

                    link={'pedido'}   
                    history='pedido'      
                    preload={this.props.preload || this.state.preloadFilter}
                                        
                    onLoad={() => this.onLoad()}                       
                    onCallbackFilter={(resposta, erro) => this.onCallbackFilter(resposta, erro)}
                    onPreloadFilter={(preloadFilter) => this.setState({preloadFilter: preloadFilter})}
                    
                    route={(route) => this.props.route(route)}    
                />
            </Fragment>         
        )
    }
}

export default Pedido;
